<template>
    <pwa_article :pwa="pwa" article_type="description"></pwa_article>
</template>

<script>
import pwa_article from "./pwa_article";
export default {
    name: "pwa_article_description",
    components : {
        pwa_article
    },
    props : {
        pwa : {
            type:Object
        }
    },
}
</script>

<style scoped>

</style>
